import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="flex items-center justify-center min-h-screen" data-testid="auth-checking">
        <Loader2 className="w-6 h-6 animate-spin text-[#0055FF]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
